module.exports = __webpack_public_path__ + "static/media/evajames.03158813.jpg";